import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';
import {Block} from '../../icons/index';
import style from '../../styles/components/button';

import './style.css';

function ButtonForget(props) {
  const {
    classes,
    customClasses,
    disabled,
    onClick,
  } = props;

  return (
    <CustomButton
      color="red"
      customClasses={customClasses}
      disabled={disabled}
      onClick={onClick}
      size="xs"
    >
      <Block className={classes.button__icon} />
      <span className="button-forget__text">{I18n.t('buttons.forget').toUpperCase()}</span>
    </CustomButton>
  );
}

ButtonForget.propTypes = {
  classes: PropTypes.object.isRequired,
  customClasses: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ButtonForget.defaultProps = {
  customClasses: '',
  disabled: false,
};

export default withStyles(style)(ButtonForget);
